export default {
  main: "Primair",
  dossier: "Dossier"
}
